import React from 'react';
import { Input, Button, PaperClip, Select, CheckboxTable, DatePicker, Table, Tooltip, Pagination } from 'components';
import { AreaService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants, Socket, SocketEvents, checkPermission, Permissions } from 'utils';
import { WhiteImage } from 'assets/img';
import moment from 'moment';
import { AddIcon, EditIcon, DeleteIcon, CloseIcon } from 'assets/icons';
import { connect } from 'react-redux';

interface Props extends RootState {
	onClose?: any;
}

class ModalAreas extends React.Component<Props> {

	state = {
		data: [],
		page: 1,
		last_page: 1,
		header: [
			'Nombre',
			'Acción'
		],
		form: {
			name: '',
			photo: ''
		},
		item: null,
		open: false
	}

	componentDidMount() {
		this.load();
	}

	load = async (withoutLoading: boolean = true) => {
		const res: any = await AreaService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
		});
		this.setState({
			data: res.areas.rows,
			last_page: res.areas.count
		});
	}

	submit = async (e: any) => {
		e.preventDefault();

		const item: any = this.state.item;

		if (item != null) {
			await AreaService.admin.edit({
				area_id: item?.id,
				...this.state.form,
			});
			this.onClose();
		}
		else {
			await AreaService.admin.create({
				...this.state.form
			});
			this.onClose();
		}
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	add = () => {
		this.setState({
			open: true,
			item: null,
			form: {
				name: ''
			}
		});
	}

	onClose = () => {
		this.setState({
			open: false,
			item: null,
			form: {
				name: ''
			}
		},() => this.load(true));
	}

	delete = async (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar la unidad?',async () => {
			await AreaService.admin.delete({
				area_id: item.id
			});
			this.load(true);
		});
	}
	
	render() {
		const { open } = this.state;

		return (
			<div id="modal-create-specialities">
				{
					open && (
						<div className="container-form">
							<div className="container-close">
								<p className="title-form">{ this.state.item != null ? 'Editar' : 'Crear' } Unidad</p>
								<button onClick={ () => this.onClose() }>
									<img src={ CloseIcon } />
								</button>
							</div>
							<form className="row" onSubmit={ this.submit }>
								<div className="col-md-12">
									<Input
										color="white"
										value={ this.state.form.name }
										name="name" 
										placeholder="Nombre"
										onChange={ this.change } />
								</div>
								<div className="col-12">
									<div className="row row-buttons">
										<div className="col-md-12 text-center">
											<Button type="submit">
												Guardar
											</Button>
										</div>
									</div>
								</div>
							</form>
						</div>
					)
				}
				<Table data={ this.state.data.length } rightAlign={[ 1 ]} header={ this.state.header } titleRight={
					<React.Fragment>
						{
							checkPermission(Constants.MODULES.SERVICES,'write',this.props.user) && (
								<Button className="btn-add" onClick={ () => this.add() }>
									<img src={ AddIcon } />
									Nuevo
								</Button>
							)
						}
					</React.Fragment>
				}>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>{ i.name }</td>
								<td className="vertical-center text-right">
									{
										checkPermission(Constants.MODULES.SERVICES,'write',this.props.user) && (
											<Tooltip title="Editar">
												<a className="link-icon" href="#" onClick={ (e: any) => {
													e.preventDefault();
													this.setState({
														open: true,
														item: i,
														form: {
															name: i.name
														}
													});
												} }>
													<img src={ EditIcon } />
												</a>
											</Tooltip>
										)
									}
									{
										checkPermission(Constants.MODULES.SERVICES,'delete',this.props.user) && (
											<Tooltip title="Eliminar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.delete(e,i) }>
													<img src={ DeleteIcon } />
												</a>
											</Tooltip>
										)
									}
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(ModalAreas);